<script setup lang="ts"></script>

<template>
  <main :class="['mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8 space-y-4', $attrs.class]">
    <slot />
  </main>
</template>
